import script from "./ProductAssets.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductAssets.vue?vue&type=script&setup=true&lang=ts"

import "./ProductAssets.vue?vue&type=style&index=0&id=52c6a317&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52c6a317"]])

export default __exports__